import React from "react";
import './Details.css';
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class Details extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            memberdetails: [],
            gender: "",
            firstName: "",
            lastName: "",
            emailAddress: "",
            mobilePhone: "",
            memberCountry: "",
            memberCity: "",
            userRole: "",
            userName: "",
            username: "",
            password: "",
            passWord: "",
            businessName: "",
            registrations: [],
            countryCities: [],
            organisations: [],
            memberStatus:"",
        }
    }

    orgs = [];
    genders = [
        { label: "Female", value: "Female" },
        { label: "Male", value: "Male" },
        { label: "Other", value: "Other" }
    ]

    countries = [
        { label: "Angola", value: "Angola" },
        { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
        { label: "Congo Democratic", value: "Congo Democratic" },
        { label: "Congo Republic", value: "Congo Republic" },
        { label: "Ghana", value: "Ghana" },
        { label: "South Africa", value: "South Africa" },
        { label: "Zimbabwe", value: "Zimbawe" },
    ]

    countriesCities = [
        { label: "Angola", value: "Luanda" },
        { label: "Angola", value: "Cubango" },
        { label: "Cote d'Ivoire", value: "Abidjan" },
        { label: "Congo Democratic", value: "Kinshasa" },
        { label: "Congo Democratic", value: "Lubumbashi" },
        { label: "Congo Democratic", value: "Mbuji Mayi" },
        { label: "Congo Republic", value: "Brazzaville" },
        { label: "Congo Republic", value: "Pointe Noire" },
        { label: "Congo Republic", value: "Dolisie" },
        { label: "Congo Republic", value: "Nkayi" },
        { label: "Congo Republic", value: "Ouesso" },
        { label: "Ghana", value: "Accra" },
        { label: "South Africa", value: "Johannesburg" },
        { label: "South Africa", value: "Cape Town" },
        { label: "South Africa", value: "Tswane" },
        { label: "South Africa", value: "Limpopo" },
        { label: "South Africa", value: "East London" },
        { label: "South Africa", value: "Durban" },
        { label: "South Africa", value: "Port Elizabeth" },
        { label: "Zimbabwe", value: "Bulawayo" },
        { label: "Zimbabwe", value: "Harare" }
    ]


    handleDetailsClose = () => {
        this.setState({
            open: false, firstName: "", lastName: "", emailAddress: "", mobilePhone: "",
            gender: "", userName: "", passWord: "", businessName: "", country: "", city: "", membershipStatus: ""
        });
        document.getElementById('successRegstration').style.display = "none";
        document.getElementById('failRegstration').style.display = "none";
        this.props.updateFromDetails();
        // this.props.onDetailsClose();
        // this.props.loadGroupMembers();
    };
    

    componentDidMount = async (e) => {
        // this.getMemberStatus();

        // this.setState({userRole: this.props.userRole});
        // this.getUserApproveRights(this.props.userRole);
        // this.memberShipStatusAction(this.props.memberhipStatus);
        //this.memberdetails = 
        // this.props.getMemberDetails();
        //   console.log( this.props.getMemberDetails())
        //  e.preventDefault();
        //    this.getMemberDetails();
        // this.getAllOrgs();
        //  console.log(this.props.memberdetails[0]['id'])

    }
    // ------------------------------- ARCHIVE 
    getCountryCities = (country) => {

        let countryCity = [];
        {
            this.countriesCities.map(item => {
                var obj = {};
                if (item.label === country) {
                    obj["label"] = item.value;
                    obj["value"] = item.value;
                    countryCity.push(obj)
                }
            })
        }
        this.setState({ countryCities: countryCity });
    }

    setUserName = (e) => {
        this.setState({
            emailAddress: e.target.value, username: e.target.value
        });
    };

    setPassword = (e) => {
        this.setState({
            passWord: e.target.value, password: e.target.value
        });
    };

    handleDetailsOpen = () => {
        this.setState({ open: true });
    };
    setGenderChange = (e) => {
        this.setState({ gender: e.label });
    }
    setFirstName = (e) => {
        this.setState({ firstName: e.target.value });
    }
    setLastName = (e) => {
        this.setState({ lastName: e.target.value });
    }
    setPhoneNumber = (e) => {
        this.setState({ mobilePhone: e.target.value });
    }
    setBusinessName = (e) => {
        this.setState({ businessName: e.label });
    }
    setCountry = (e) => {
        this.setState({ country: e });
        this.getCountryCities(e);
    }
    setCity = (e) => {
        this.setState({ city: e });
    }

    saveMemberStatus = async (e) => {
       // e.stopPropagation();
       // this.sendRegistration();
       if(this.state.memberStatus ===""){
        alert("Please select an option: Approve/ Cancel");
        return false;
       }
       else{
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social", "businessname": this.props.businessname , "memberid": this.props.recordid,
                  "memberstatus":this.state.memberStatus, "modified": this.props.username}

        }
       // const url = "http://localhost/kimvuka-php/api/saveMemberStatus.php";
        const url = "https://testmembership.bktsystems.com/api/saveMemberStatus.php";
        const response = await axios.get(url, config);
        console.log(response.data);
        this.handleDetailsClose();
        //this.setState({ registrations: response.data });

       }
    }
    getAllRegistrations = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social" }

        }
      //  const url = "http://localhost/kimvuka-php/api/getAllusers.php";
        const url = "https://testmembership.bktsystems.com/api/getAllusers.php";
        const response = await axios.get(url, config);
        console.log(response.data);
        this.setState({ registrations: response.data });
    }

    handleMemberShipApprove = (e) => {
        if (e.target.checked === true) {
            this.setState({memberStatus: "Approved"});
            document.getElementById('cancel').checked = false;
        }
    }
    handleMemberShipCancel = (e) => {
        if (e.target.checked === true) {
            this.setState({memberStatus: "Cancelled"});
            document.getElementById('approve').checked = false;
        }
    }
    memberShipStatusAction = (status) => {
        if (status === 'Submitted') {
            document.getElementById('approve').checked = false;
        }

    }
    statusText = (strStatus) => {
        switch (strStatus) {
            case 'Submitted':
                return "Pending approval";
                break;
            case 'Approved':
                return "Confirmed member";
                break;
            case 'Cancelled':
                return "Cancelled membership";
                break;
            // ... more cases
            default:
                return "Unknown status";
                break;
        }
    }
    statusTextStyle = (strStatus) => {
        switch (strStatus) {
            case 'Submitted':
                return "pendingLabel";
                break;
            case 'Approved':
                return "Confirmed member";
                break;
            case 'Cancelled':
                return "Cancelled membership";
                break;
            // ... more cases
            default:
                return "Unknown status";
                break;
        }
    }

    membership_status = this.statusText(this.props.memberhipStatus);
    membershipTextSyle = this.statusText(this.props.memberhipStatus);
    //memberDependents = this.props.getMemberDepedents;
    getAllOrgs = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social" }

        }
        //const url = "http://localhost/kimvuka-php/api/getAllOrgs.php";
        const url = "https://testmembership.bktsystems.com/api/getAllOrgs.php";
        const orgresponse = await axios.get(url, config);
        //console.log(orgresponse.data);
        this.setState({ organisations: orgresponse.data });

        orgresponse.data.map(key => {
            this.orgs.push({
                label: key.name, value: key.name
            });
        })
    }

    getStuff = () => {
        let members = this.props.MymemberDependents;
        if (members) {
            console.log('>>>>>>>>>>')
        }
    }

    sendRegistration = async (e) => {
        let userFound = false;
        if (this.state.emailAddress !== "") {
            this.state.registrations.map(item => {
                if (item.emailaddress.replace(/\s/g, '').toLowerCase() === this.state.emailAddress.replace(/\s/g, '').toLocaleLowerCase()) {
                    return userFound = true;
                }

            })
        }
        let color = ""
        if (userFound === true) {
            alert("Registration with this user account exists already!");
            return false;
        }
        else {
            if ((this.state.gender === "") || (this.state.firstName === "") || (this.state.emailAddress === "") || (this.state.mobilePhone === "")
                || (this.state.businessName === "") || (this.state.passWord === "") || (this.state.city === "") || (this.state.country === "")) {
                alert("Please provide all required fields!")
                return false;
            }
            else {
                let config = {
                    headers: { 'Accept': 'application/json' },
                    params: {
                        'firstname': this.state.firstName,
                        'lastname': this.state.lastName,
                        'emailaddress': this.state.emailAddress,
                        'mobilephone': this.state.mobilePhone,
                        'gender': this.state.gender,
                        'username': this.state.userName,
                        'password': this.state.passWord,
                        'businessname': this.state.businessName,
                        'country': this.state.country,
                        'city': this.state.city

                    }
                }
               // const url = "http://localhost/kimvuka-php/api/getRegister.php";
                const url = "https://testmembership.bktsystems.com/api/getRegister.php";
                const response = await axios.get(url, config
                )
                console.log(response.data);
                this.setState({ firstName: "", lastName: "", emailAddress: "", mobilePhone: "", gender: "", userName: "", passWord: "", businessName: "", country: "", city: "" });
                if (response.data.includes("Registration sucessfully received.") === true) {
                    document.getElementById('successRegstration').style.display = "block";
                    document.getElementById('submitDetails').style.display = "none";
                    //alert("Thank you, your registration request has been received. We will contact you once your account is setup.");
                }
                else {
                    //alert("There was an error, please try again later.");
                    document.getElementById('failRegstration').style.display = "block";
                }
            }
        }
    }

    render() {

        return (
            <div>
                <div >
                    <Modal ariaHideApp={false} isOpen={this.state.open} onClose={this.handleDetailsClose}>
                        <Form >
                            {(() => {

                                if (this.props.membershipStatus === 'Submitted') {
                                    this.color = "lightyellow"                                    
                                }

                                if (this.props.membershipStatus === 'Approved') {
                                    this.color = "rgb(212, 243, 213)"
                                    document.getElementById('approve').disabled = true
                                }

                                if (this.props.membershipStatus === 'Cancelled') {
                                    this.color = "lightred"
                                }
                                if (this.props.membershipStatus === 'No registration found!') {
                                    this.color = "lightgray"
                                    document.getElementById('approve').disabled = true
                                    document.getElementById('cancel').disabled = true                                   
                                
                                 }
                                // console.log('------'+this.color)

                            }
                            )()}
                            <div className="maindiv" style={{ backgroundColor: `${this.color}`, borderRadius: "10px", paddingLeft:"5px", paddingTop:"5px", paddingBottom:"10px" }}>
                                <div >
                                    <div style={{ textAlign: "center" }}><Label> <h4>MEMBER'S DETAILS</h4></Label></div>
                                    <div style={{ paddingBottom: "10px" }}>
                                        <span className="businessname"><h4>{this.props.businessname}</h4></span>
                                    </div>

                                    <FormGroup>
                                        {/* {this.membership_status} */}
                                        Membership status: <Label for="membership_status" style={{ color: "#de993c", fontWeight: "bold" }}><h4>{this.props.membershipStatus}</h4></Label>
                                    </FormGroup>
                                </div>
                                <FormGroup>
                                    <Label for='gender'>Gender</Label>
                                    <Select
                                        //  options={this.genders}
                                        maxMenuHeight="100%"
                                        defaultInputValue={this.props.memberGender}
                                        //   onChange={this.setGenderChange}
                                        value={this.props.memberGender}
                                        key={this.props.memberGender}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='maritalStatus'>Marital status</Label>
                                    <Select
                                        //  options={this.genders}
                                        maxMenuHeight="100%"
                                        defaultInputValue={this.props.maritalStatus}
                                        key={this.props.maritalStatus}
                                    //   onChange={this.setGenderChange}
                                    //  value={this.props.maritalStatus}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='firstname'>First name</Label>
                                    <Input
                                        type='text'
                                        id='firstName'
                                        name='firstName'
                                        // value={this.state.firstName}
                                        value={this.props.memberName}
                                    // onChange={this.setFirstName}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for='lastname'>Last name</Label>
                                    <Input
                                        type='text'
                                        id='lastName'
                                        name='lastName'
                                        // value={this.state.lastName}
                                        value={this.props.memberSurName}
                                        onChange={this.setLastName}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for='phonenumber'>Phone Number</Label>
                                    <Input
                                        type='number'
                                        id='phonenumber'
                                        name='phonenumber'
                                        //  placeholder="+271234567896"
                                        value={this.props.mobilePhone}
                                    //  onChange={this.setPhoneNumber}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="username">Email address</Label>
                                    <Input
                                        id="userName"
                                        name="userName"
                                        // placeholder="e-mail address"
                                        //onChange={this.setUserName}
                                        type="email"
                                        value={this.props.email}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="dob">Date of birth</Label>
                                    <Input
                                        id="dob"
                                        name="dob"
                                        // placeholder="Set password"
                                        // onChange={this.setPassword}
                                        type="text"
                                        value={this.props.memberDob}//{this.state.passWord}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for='join_date'>Join date</Label>
                                    <Input
                                        id="join_date"
                                        name="join_date"
                                        // placeholder="Set password"
                                        // onChange={this.setPassword}
                                        type="text"
                                        value={this.props.memberJoinDate}//{this.state.passWord}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for='country'>Country</Label>
                                    <Select
                                        // options={this.countries}
                                        maxMenuHeight="100%"
                                        defaultInputValue={this.props.memberCountry}
                                        key={this.props.memberCountry}
                                    //   onChange={opt => this.setCountry(opt.label)}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for='city'>City</Label>
                                    <Select
                                        // options={this.state.countryCities}
                                        maxMenuHeight="100%"
                                        defaultInputValue={this.props.memberCity}
                                        // onChange={opt => this.setCity(opt.label)}
                                        value={this.props.memberCity}
                                        key={this.props.memberCity}
                                    ></Select>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="address">Physical address</Label>
                                    <Input
                                        id="address"
                                        name="address"
                                        //   onChange={this.setAddress}
                                        type="textarea"
                                        rows="2"
                                        value={this.props.address}
                                    />
                                </FormGroup>
                                {/*----------------------------*/}
                                <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                    <div style={{ textAlign: "center" }}><Label> <h4>DEPENDENTS DETAILS</h4></Label></div>
                                    {(() => {

                                        if (Array.isArray(this.props.customDependents)) {

                                            return (

                                                <table style={{ width: "100%", borderBottom: "1px solid white", borderCollapse: "collapse" }}>
                                                    <tr style={{ height: "5px", borderBottom: "1px solid white" }}>
                                                        <th> Gender</th>
                                                        <th> Full name</th>
                                                        <th> Phone</th>
                                                        <th> Relation</th>
                                                    </tr>
                                                    {
                                                        this.props.customDependents.map((row, index) => {
                                                            //console.log('>>>>>>' + row.fullname)
                                                            return (<tr key={index} style={{ height: "25px", borderBottom: "1px solid white", width: "25px" }}>
                                                                <>
                                                                    <td><Label style={{ color: "darkblue" }} >{row.gender}</Label></td>
                                                                    <td><Label style={{ color: "darkblue" }}>{row.fullname}</Label></td>
                                                                    <td><Label style={{ color: "darkblue" }}>{row.phone}</Label></td>
                                                                    <td><Label style={{ color: "darkblue" }}>{row.relationship}</Label></td>
                                                                </>
                                                            </tr>
                                                            );
                                                        })
                                                    }
                                                </table>)
                                        }
                                        else {
                                            return (
                                                <>
                                                    <div style={{ paddingBottom: "10px" }}>
                                                        <div style={{ textAlign: "center" }}><label style={{ textAlign: "center", fontWeight: "bold", color: "darkorange" }}>No dependant recorded</label></div>
                                                    </div>
                                                </>
                                            );
                                        }
                                    })()}
                                </div>
                                {/*----------------------------*/}
                                <div style={{ paddingBottom: "10px" }}>
                                    <div id="approveDiv" style={{ display: 'none' }}>
                                        <span style={{ paddingRight: "10px" }}>
                                            <label>
                                                <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                                    type='checkbox'
                                                    name='approve'
                                                    id='approve'
                                                    /* defaultChecked={true} */
                                                    onChange={this.handleMemberShipApprove}
                                                />
                                                Approve
                                            </label>
                                        </span>

                                        <span style={{ paddingLeft: "10px" }}>
                                            <label>
                                                <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                                    type='checkbox'
                                                    name='cancel'
                                                    id='cancel'
                                                    onChange={this.handleMemberShipCancel}
                                                />
                                                Cancel
                                            </label>
                                        </span>
                                    </div>
                                </div>
                                <div id='successRegstration' style={{ textAlign: "center", color: "green", display: "none" }}><Label> <h4>Registration sent, thank you!</h4></Label></div>
                                <div id='failRegstration' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>Registration failed!</h4></Label></div>
                                <div id='submitDetails' style={{ paddingTop: "20px" }}>
                                    <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", fontWeight: "bold", color: "white" }} type="button" onClick={this.saveMemberStatus}>Submit</Button>
                                </div>

                                <div style={{ paddingTop: "20px" }}>
                                    <Button style={{ width: "100%", fontWeight: "bold" }}
                                        onClick={this.handleDetailsClose}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </Modal>
                </div>
            </div >
        );

    }

}
export default Details